import isHtmlElementNode from '@atlas/tool/box/dom/isHtmlElementNode';

export default function isOneLineTextHtmlElement(node: Node): node is TOneLineTextHtmlElement {
    return (
        isHtmlElementNode(node, 'P') ||
        isHtmlElementNode(node, 'DIV') ||
        isHtmlElementNode(node, 'H1') ||
        isHtmlElementNode(node, 'H2') ||
        isHtmlElementNode(node, 'H3') ||
        isHtmlElementNode(node, 'H4') ||
        isHtmlElementNode(node, 'H5') ||
        isHtmlElementNode(node, 'H6')
    );
}

// #region Types

export type TOneLineTextHtmlElement =
    | (HTMLParagraphElement & { tagName: 'P' })
    | (HTMLDivElement & { tagName: 'DIV' })
    | (HTMLHeadingElement & { tagName: 'H1' | 'H2' | 'H3' | 'H4' | 'H5' | 'H6' });

// #endregion

// #region Tests

if (import.meta.vitest) {
    const { describe, test, expect, expectTypeOf } = import.meta.vitest;
    describe('isOneLineTextHtmlElement', () => {
        test('results with false for non-html elements', () => {
            expect(isOneLineTextHtmlElement(document)).toBe(false);
            expect(isOneLineTextHtmlElement(document.createTextNode('text'))).toBe(false);
        });

        test('results with true only for one-line text html elements', () => {
            expect(isOneLineTextHtmlElement(document.createElement('p'))).toBe(true);
            expect(isOneLineTextHtmlElement(document.createElement('div'))).toBe(true);
            expect(isOneLineTextHtmlElement(document.createElement('h1'))).toBe(true);
            expect(isOneLineTextHtmlElement(document.createElement('h2'))).toBe(true);
            expect(isOneLineTextHtmlElement(document.createElement('h3'))).toBe(true);
            expect(isOneLineTextHtmlElement(document.createElement('h4'))).toBe(true);
            expect(isOneLineTextHtmlElement(document.createElement('h5'))).toBe(true);
            expect(isOneLineTextHtmlElement(document.createElement('h6'))).toBe(true);
            expect(isOneLineTextHtmlElement(document.createElement('iframe'))).toBe(false);
        });

        test('justifies type of the given node to match the result of comparison', () => {
            const node: Node = document;

            isOneLineTextHtmlElement(node)
                ? expectTypeOf(node).toMatchTypeOf<HTMLParagraphElement | HTMLDivElement | HTMLHeadingElement>()
                : expectTypeOf(node).not.toMatchTypeOf<HTMLParagraphElement | HTMLDivElement | HTMLHeadingElement>();
        });
    });
}

// #endregion
